import { render } from "./JoinBets.vue?vue&type=template&id=30ed638a"
import script from "./JoinBets.vue?vue&type=script&lang=js"
export * from "./JoinBets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__